import { useEffect, useState } from "react";
import api from "@/lib/api";
import DashboardShell from "@/components/nav/DashboardShell";

const STATUSES = ["ALL","NEW","QUEUED","WORKING","WAITING ON APPROVAL","COMPLETED","FAILED","CANCELLED"];

export default function Tasks() {
  const [tasks, setTasks] = useState([]);
  const [filter, setFilter] = useState("ALL");

  useEffect(() => {
    const q = filter === "ALL" ? "" : `?status=${encodeURIComponent(filter)}`;
    api.get(`/tasks${q}`).then(({data}) => setTasks(data)).catch(() => {});
  }, [filter]);

  return (
    <DashboardShell>
      <div className="brand-eyebrow mb-4">WORK</div>
      <h1 className="brand-headline text-4xl md:text-6xl mb-8">Tasks.</h1>

      <div className="flex gap-2 flex-wrap mb-6">
        {STATUSES.map(s => (
          <button key={s} data-testid={`tasks-filter-${s.split(' ')[0].toLowerCase()}`} onClick={() => setFilter(s)}
            className={`text-[10px] tracking-widest font-bold px-3 py-1.5 border ${filter===s ? "bg-gold text-ink border-gold" : "text-smoke border-line hover:border-gold"}`}>{s}</button>
        ))}
      </div>

      <div className="border border-line divide-y divide-line">
        {tasks.length === 0 && <div className="p-10 text-smoke text-sm">No tasks in this filter.</div>}
        {tasks.map(t => (
          <div key={t.id} className="p-6">
            <div className="flex items-start justify-between gap-4 flex-wrap">
              <div className="flex-1 min-w-0">
                <div className="text-[10px] tracking-widest text-smoke font-mono">{t.id.slice(0,8)} · {t.ai_employee_slug}</div>
                <div className="text-white mt-1">{t.description}</div>
                {t.ai_output && <div className="mt-3 text-smoke text-sm whitespace-pre-wrap bg-white/[0.02] p-4 border border-line max-h-64 overflow-auto">{t.ai_output}</div>}
              </div>
              <div className="text-right shrink-0">
                <span className={`text-[10px] tracking-widest font-bold ${t.status==='COMPLETED'?'text-emerald-400':t.status==='FAILED'?'text-red-400':t.status.startsWith('WAITING')?'text-amber-400':'text-smoke'}`}>{t.status}</span>
                <div className="text-[11px] text-smoke mt-2">{new Date(t.created_at).toLocaleString()}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </DashboardShell>
  );
}
